import type { SVGProps } from "react";

export default function MinusIcon(props: Readonly<SVGProps<SVGSVGElement>>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 12 2"
      fill="none"
      {...props}
    >
      <path
        d="M11.224 1H0.775879"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
    </svg>
  );
}
